/**
 * MLB team id + display name (Stats API / mlbstatic.com logo ids).
 * Keep in sync with api/mlb_teams.py TEAM_NAME_TO_ID for new franchises.
 */

/** @type {{ id: number, name: string }[]} */
export const MLB_TEAMS = [
  { id: 109, name: 'Arizona Diamondbacks' },
  { id: 144, name: 'Atlanta Braves' },
  { id: 110, name: 'Baltimore Orioles' },
  { id: 111, name: 'Boston Red Sox' },
  { id: 145, name: 'Chicago White Sox' },
  { id: 112, name: 'Chicago Cubs' },
  { id: 113, name: 'Cincinnati Reds' },
  { id: 114, name: 'Cleveland Guardians' },
  { id: 115, name: 'Colorado Rockies' },
  { id: 116, name: 'Detroit Tigers' },
  { id: 117, name: 'Houston Astros' },
  { id: 118, name: 'Kansas City Royals' },
  { id: 108, name: 'Los Angeles Angels' },
  { id: 119, name: 'Los Angeles Dodgers' },
  { id: 146, name: 'Miami Marlins' },
  { id: 158, name: 'Milwaukee Brewers' },
  { id: 142, name: 'Minnesota Twins' },
  { id: 121, name: 'New York Mets' },
  { id: 147, name: 'New York Yankees' },
  { id: 133, name: 'Oakland Athletics' },
  { id: 143, name: 'Philadelphia Phillies' },
  { id: 134, name: 'Pittsburgh Pirates' },
  { id: 135, name: 'San Diego Padres' },
  { id: 137, name: 'San Francisco Giants' },
  { id: 136, name: 'Seattle Mariners' },
  { id: 138, name: 'St. Louis Cardinals' },
  { id: 139, name: 'Tampa Bay Rays' },
  { id: 140, name: 'Texas Rangers' },
  { id: 141, name: 'Toronto Blue Jays' },
  { id: 120, name: 'Washington Nationals' },
].sort((a, b) => a.name.localeCompare(b.name));

/**
 * @param {number | string | null | undefined} teamId
 * @returns {{ id: number, name: string } | undefined}
 */
export function mlbTeamById(teamId) {
  const n = Number(teamId);
  if (!Number.isFinite(n)) return undefined;
  return MLB_TEAMS.find((t) => t.id === n);
}

/**
 * @param {number | string | null | undefined} teamId
 * @param {string | null | undefined} nameFromUrl
 * @returns {string}
 */
export function resolveMlbTeamDisplayName(teamId, nameFromUrl) {
  const trimmed = nameFromUrl != null ? String(nameFromUrl).trim() : '';
  if (trimmed) return trimmed;
  const meta = mlbTeamById(teamId);
  if (meta) return meta.name;
  const n = Number(teamId);
  return Number.isFinite(n) ? `Team ${n}` : '';
}
